export default __webpack_public_path__ + "static/media/phone.85d00537.gif";